import React from "react";
import "../../pages/Dashboard.scss";

export type ProgressStatus = "pending" | "active" | "completed";

export interface ProgressStep {
  id?: string;
  title?: string;
  status?: ProgressStatus;
  gap?: boolean;
}

interface Props {
  steps: ProgressStep[];
}

export default function StaticProgressTracker({ steps }: Props) {
  // Build final static version of steps:
  // → All non-gap steps except last: completed
  // → Last non-gap step: active (with rotating class)
  const finalSteps = (() => {
    const nonGapSteps = steps.filter((s) => !s.gap);
    const lastIndex = nonGapSteps.length - 1;

    return steps.map((step) => {
      if (step.gap) return step;

      const index = nonGapSteps.findIndex((s) => s.id === step.id);
      const isLast = index === lastIndex;

      return {
        ...step,
        status: (isLast ? "active" : "completed") as ProgressStatus,
      };
    });
  })();

  return (
    <div className="chat-progress-tracker">
      {finalSteps.map((step, index) =>
        step.gap ? (
          <div key={`gap-${index}`} style={{ height: 16 }} />
        ) : (
          <div key={step.id} className={`progress-step ${step.status}`}>
            <div className="progress-step-icon">
              <div
                className={`progress-circle ${step.status} ${
                  step.status === "active"
                }`}
              />
            </div>

            <div className="progress-step-content">
              <div className="progress-step-title">{step.title}</div>
              <div className="progress-step-status">
                Completed
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}
